var CODE_ENV = process.env.NEXT_PUBLIC_CODE_ENV || 'develop';
export function log(message) {
  if (['develop', 'staging'].includes(CODE_ENV) || typeof window !== 'undefined' && window.CODE_DEBUG) {
    var _console;
    for (var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      optionalParams[_key - 1] = arguments[_key];
    }
    (_console = console).log.apply(_console, [message].concat(optionalParams));
  }
}